import { render, staticRenderFns } from "./ReportView.vue?vue&type=template&id=5622b9fb&scoped=true&"
import script from "./ReportView.vue?vue&type=script&lang=js&"
export * from "./ReportView.vue?vue&type=script&lang=js&"
import style0 from "./ReportView.vue?vue&type=style&index=0&id=5622b9fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622b9fb",
  null
  
)

export default component.exports